export const CognitoPermissionGroups = {
  // Multi feature access
  isService: 'isService',
  isSales: 'isSales',
  isInternalSales: 'isInternalSales',
  isExternalSales: 'isExternalSales',
  isTeamLeader: 'isTeamLeader',
  isAgency: 'isAgency',
  isInternalAgent: 'isInternalAgent',
  isUnlicensed: 'isUnlicensed', // completely unlicensed, no access to quote in any state
  canAccessProtectedUDDActions: 'canAccessProtectedUDDActions',

  // Individual feature access
  canQuote: 'canQuote',
  canEditPolicies: 'canEditPolicies',
  canEditOffers: 'canEditOffers',
  canViewPolicies: 'canViewPolicies',
  canViewOffers: 'canViewOffers',
  canEdit: 'canEdit',
  canBind: 'canBind',
  canBindDirectly: 'canBindDirectly',
  canViewCheckoutPage: 'canViewCheckoutPage',
  canReinstate: 'canReinstate',
  canRescindCancellation: 'canRescindCancellation',
  canSeeFullOfferDetails: 'canSeeFullOfferDetails',
  canScrubIncidents: 'canScrubIncidents',
  canAddIncidents: 'canAddIncidents',
  canModifyAffinityAndLeadSource: 'canModifyAffinityAndLeadSource',
  canBackDate: 'canBackDate',
  canUploadDocuments: 'canUploadDocuments',
  canDeleteInternalDocuments: 'canDeleteInternalDocuments',
  canOverrideAllRejections: 'canOverrideAllRejections',
  canModifyBillingId: 'canModifyBillingId',
  canViewClarionDoorData: 'canViewClarionDoorData',
  canAddCarsManually: 'canAddCarsManually',
  canAutoRenew: 'canAutoRenew',
  canAddHoldCards: 'canAddHoldCards',
  canChangeExclusions: 'canChangeExclusions',
  canToggleEmployeeDiscount: 'canToggleEmployeeDiscount',
  canClearUDRs: 'canClearUDRs',
  viewOnly: 'viewOnly',
  canEditHomeAddress: 'canEditHomeAddress',
  canEditEffectiveDate: 'canEditEffectiveDate',
  canManuallyChargeFee: 'canManuallyChargeFee',
  canQuoteBranchPlus: 'canQuoteBranchPlus',
  canClearUWFormRejections: 'canClearUWFormRejections',
  canManuallyChargePolicy: 'canManuallyChargePolicy',
  canRewritePolicy: 'canRewritePolicy',
  canRemoveExcludedDriver: 'canRemoveExcludedDriver',
  canCancelReasonCNIP: 'canCancelReasonCNIP',
  canCancelReasonCNMS: 'canCancelReasonCNMS',
  canCancelReasonCNPY_X: 'canCancelReasonCNPY_X',
  canRejectPIP: 'canRejectPIP',
  showAgencyPortal: 'showAgencyPortal',
  canDownloadAnonDocs: 'canDownloadAnonDocs',
  canReinstateCNPY: 'canReinstateCNPY',
  canToggleCreditCheck: 'canToggleCreditCheck',
  canEditBillingDay: 'canEditBillingDay',
  canToggleCHDiscount: 'canToggleCHDiscount',
  canToggleInventoryDiscount: 'canToggleInventoryDiscount',
  canEditPolicyMPD: 'canEditPolicyMPD',
  canDelayPaymentOrRefund: 'canDelayPaymentOrRefund',
  canManageBillingHolds: 'canManageBillingHolds',
  canManageSweepAccount: 'canManageSweepAccount',
  canSendPaperDocs: 'canSendPaperDocs',
  canEditFeeCheckbox: 'canEditFeeCheckbox',
  canOverrideGaragingAddress: 'canOverrideGaragingAddress',
  canSwapApplicants: 'canSwapApplicants',
  canViewCarrierInitiatedCancels: 'canViewCarrierInitiatedCancels',
  canSellAndService: 'canSellAndService',
  canCancelReasonNACP: 'canCancelReasonNACP',
  canEditUneditablePropertyDetailsFields: 'canEditUneditablePropertyDetailsFields',
  canResetOnboardingTasks: 'canResetOnboardingTasks',
  canCancelOnboardingTasks: 'canCancelOnboardingTasks',
  canViewInternalTasks: 'canViewInternalTasks',
  canViewUWCancelCodes: 'canViewUWCancelCodes',
  canToggleIsAgencyPolicy: 'canToggleIsAgencyPolicy',
  canSkipEmailConfirmationSplashPage: 'canSkipEmailConfirmationSplashPage',
  canRefundStripePayment: 'canRefundStripePayment',
  canRescindOrReinstateGSNICPolicy: 'canRescindOrReinstateGSNICPolicy',
  canRemoveFinalPaymentMethod: 'canRemoveFinalPaymentMethod',
  canBypassDriversLicenseCheck: 'canBypassDriversLicenseCheck',
  canSeeMarketTierCard: 'canSeeMarketTierCard',
  canEditCoverageA: 'canEditCoverageA',
  // Descope authority to check/edit/uncheck the Coverage A & Coverage E limit override, which locks
  // the overridden limit against edits by anyone without this authority (#35617). Granted to no role
  // by default; additionally gated by the brand `featureFlags.coverageLimitOverride` flag.
  canOverrideCoverageLimit: 'canOverrideCoverageLimit',
  canWriteMultipleAffinityCodes: 'canWriteMultipleAffinityCodes',
  canEditDriversName: 'canEditDriversName',
  canModifyNonRatedIndividual: 'canModifyNonRatedIndividual',
  canUploadTaskCenterDocuments: 'canUploadTaskCenterDocuments',
  canRevertPolicyDetails: 'canRevertPolicyDetails',
  canToggleHomeRepairsRequested: 'canToggleHomeRepairsRequested',
  canEditPriorCarrierDetails: 'canEditPriorCarrierDetails',
  canSkipOfferUnderwritingRules: 'canSkipOfferUnderwritingRules',
  canEditFarmPolicyAdjustment: 'canEditFarmPolicyAdjustment',
  canApproveUWReview: 'canApproveUWReview',
  // Internal-only access to the brand's executive management report link (#35090)
  canViewReports: 'canViewReports',
  // Derived from the Agency Role field via the `Agency Principal` Descope role (#35833)
  isAgencyPrincipal: 'isAgencyPrincipal',
  // Agency reports (Book of Business), scoped server-side to the user's own stem (#35833)
  canViewAgencyReports: 'canViewAgencyReports',

  // tools permissions
  canViewTools: 'canViewTools',
  canUseStaffToolsChat: 'canUseStaffToolsChat',
  canViewAffinityTools: 'canViewAffinityTools',
  canManageAor: 'canManageAor',
  canViewStaffDashboard: 'canViewStaffDashboard',
  canGenerateDescopePasskeyReport: 'toolsCanGenerateDescopePasskeyReport',
  canResetStaffUserPassword: 'canResetStaffUserPassword',
  canCreateStripeCharge: 'canCreateStripeCharge',
  canCreateChargedeskInvoice: 'canCreateChargedeskInvoice',
  canBulkDisableStaffUsers: 'canBulkDisableStaffUsers',
  canCreateChargedeskRefundInvoice: 'canCreateChargedeskRefundInvoice',
  canRegeneratePolicyForm: 'canRegeneratePolicyForm',
  canGenerateLoe: 'canGenerateLoe',
  canUpdateChargedeskRecord: 'canUpdateChargedeskRecord',
  canUpdateChargedeskRecordPolicyOrBillingId: 'canUpdateChargedeskRecordPolicyOrBillingId',
  canGenerateRenewal: 'canGenerateRenewal',
  canRunRenewalUnderwriting: 'canRunRenewalUnderwriting',
  canReimportForrestonRenewal: 'canReimportForrestonRenewal',
  canUpdateStaffUser: 'canUpdateStaffUser',
  canDisableStaffUser: 'canDisableStaffUser',
  canViewEditGroups: 'canViewEditGroups',
  canRunAddressesThroughCherre: 'canRunAddressesThroughCherre',
  canUpdatePolicyRep: 'canUpdatePolicyRep',
  canBackfillPremiumBreakdown: 'canBackfillPremiumBreakdown',
  canAddPermissionGroupsToStaffUsers: 'canAddPermissionGroupsToStaffUsers',
  canCreateStaffUser: 'canCreateStaffUser',
  canCreateFrontTicket: 'canCreateFrontTicket',
  canViewStateRateChangeDashboard: 'canViewStateRateChangeDashboard',
  canViewMoratoriumDashboard: 'canViewMoratoriumDashboard',
  canImportPoliciesToSnapsheet: 'canImportPoliciesToSnapsheet',
  canImportPoliciesToIvans: 'canImportPoliciesToIvans',
  canRegeneratePolicyCancelForm: 'canRegeneratePolicyCancelForm',
  canAddCatTagsToClaims: 'canAddCatTagsToClaims',
  canRunBillingActions: 'canRunBillingActions',
  canRunCorrectiveActions: 'canRunCorrectiveActions',
  canRunIvansActions: 'canRunIvansActions',
  canCopyPolicy: 'canCopyPolicy',
  canSetMemberAffinity: 'canSetMemberAffinity',
  canEnableStaffUser: 'canEnableStaffUser',
  canResetPasskeys: 'canResetPasskeys',
  canRunTechTasks: 'canRunTechTasks',
  canPullDrivingHistoryFromCSV: 'canPullDrivingHistoryFromCSV',
  canSetHasAutoPolicy: 'canSetHasAutoPolicy',
  canUpdateBillingId: 'canUpdateBillingId',
  canOverrideUmbrellaLimit: 'canOverrideUmbrellaLimit',
  canChangeOfferAffinity: 'canChangeOfferAffinity',
  canUpdateStaffUsername: 'canUpdateStaffUsername',
  canUpdateMortgage: 'canUpdateMortgage',
  canBackfillData: 'canBackfillData',
  canCleanInforceVehicles: 'canCleanInforceVehicles',
  canCreateCompaniesInRoutable: 'canCreateCompaniesInRoutable',
  // Monthly agency production report email from a CSV (#36517)
  canSendAgencyReports: 'canSendAgencyReports',
  canSkipMatchingActivePolicySearch: 'canSkipMatchingActivePolicySearch',
  canViewPolicyOverridesTool: 'canViewPolicyOverridesTool',
  canViewOfferOverridesTool: 'canViewOfferOverridesTool',
  canBulkOrderInspections: 'canBulkOrderInspections',
  canOverrideBrandedTitle: 'canOverrideBrandedTitle',
  canOverrideMSRP: 'canOverrideMSRP',
  canOverrideExcludedCar: 'canOverrideExcludedCar',
  canOverrideLoanNumVal: 'canOverrideLoanNumVal',
  canOverrideApplicationSigningExpiry: 'canOverrideApplicationSigningExpiry',
  canOverrideVehiclesPerDriver: 'canOverrideVehiclesPerDriver',
  canAllowMonthlyPayments: 'canAllowMonthlyPayments',
  canBulkDownloadPolicyDocuments: 'canBulkDownloadPolicyDocuments',
  canAllowWaterBackup: 'canAllowWaterBackup',
  canAllowAuxRating: 'canAllowAuxRating',
  canViewAiValidation: 'canViewAiValidation',
  canSeeHomeCharacteristicsDataset: 'canSeeHomeCharacteristicsDataset',
  canRefreshCharacteristicsAndRateOffer: 'canRefreshCharacteristicsAndRateOffer',
  toolsDeleteRenewalSegment: 'toolsDeleteRenewalSegment',
  toolsCanDeleteMigratedPolicy: 'toolsCanDeleteMigratedPolicy',
  toolsCanTransferInsuranceScores: 'toolsCanTransferInsuranceScores',
  canRemoveAutoViolation: 'canRemoveAutoViolation',
  canAddViolationToOffer: 'canAddViolationToOffer',
  canAddHomeClaim: 'canAddHomeClaim',
  toolsOverrideReplacementCost: 'toolsOverrideReplacementCost',
  canRetryOfferOptions: 'canRetryOfferOptions',
  toolsCreateUddReviewTask: 'toolsCreateUddReviewTask',
  canSimulateSource: 'canSimulateSource',
  canManageDialpadCampaigns: 'canManageDialpadCampaigns',
  canExportEasyKeyXML: 'canExportEasyKeyXML',
  toolAllOverridesAccess: 'toolAllOverridesAccess'
};

export const PermissionRequireTypes = {
  All: 'all',
  AtLeastOne: 'atLeastOne'
};
